<template>
    <a-modal v-model="visible" title="Edit Sales" :destroyOnClose="true">
      <a-form-model ref="editUserForm" :model="Sales" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Name" prop="name">
            <a-input placeholder="Name" v-model="Sales.name"  />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Surname" prop="surname">
            <a-input placeholder="Surname" v-model="Sales.surname" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Initial" prop="initial">
            <a-input placeholder="Initial" v-model="Sales.initial" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Email" prop="emailAddress">
            <a-input placeholder="Email" v-model="Sales.emailAddress" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
      <template #footer>
        <a-button type="primary" @click="save" :loading="isSaving">Save</a-button>
        <a-button @click="cancel">Cancel</a-button>
      </template>
    </a-modal>
  </template>
  <script>
  import { salesHandlerMutations } from '../../Store/store';
  import { helper } from '../../Utilities/helper';
  
  export default {
    props: {
      value: Boolean,
      Sales: {
        type: Object,
        defualt: () => ({}),
      },
      businesses: Array,
    },
    data() {
      return {
        rules: {
          name: [{ required: true, message: 'Please input name', trigger: 'blur' }],
          surname: [{ required: true, message: 'Please input surname', trigger: 'blur' }],
          initial: [{ required: true, message: 'Please input initial', trigger: 'blur' }],
          emailAddress: [
            { required: true, message: 'Please input an email', trigger: 'blur' },
            { validator: this.userEmailValidator, trigger: 'blur' },
          ],
        },
        isSaving: false,
      };
    },
    computed: {
      visible: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        },
      },
    },
    methods: {
      cancel() {
        this.visible = false;
      },
    async userEmailValidator(rule, value, callback) {
          if (!helper.validateEmail(value)) {
              callback('Please input valid email address!');
          } else if (!(await helper.userCanRegisterEmail(value,this.Sales.salesId))) {
              callback('Email already registered!');
          } else {
              callback();
          }
      },
      save() {
        this.$refs.editUserForm.validate(async (valid) => {
          if (valid) {
            this.isSaving = true;
            try {
              await salesHandlerMutations.updateUser({
                salesId: this.Sales.salesId,
                name: this.Sales.name,
                surname: this.Sales.surname,
                initial: this.Sales.initial,
                emailAddress: this.Sales.emailAddress,
              });
  
              this.visible = false;
            } catch (error) {
              this.$message.error(error.response?.data?.errors[0].errorMessage ?? error.message);
            } finally {
              this.isSaving = false;
            }
          }
        });
      },
    },
  };
  </script>